export default (lang: number) => {
    return useFetch(`/api/height?lang=${lang}`)
}
